import vehicleImg from "../assets/images/vehicle_car.png";
import '../styles/VehicleCard.css';
import { locationIcon, meterIcon, wrenchIcon } from '../utils/svgs';

const VehicleCard = ({ row }) => {
    return (
        <div className='vehicle_card_wrapper'>
            <div>
                <img src={vehicleImg} alt="Vehicle" style={{ width: "45px" }} />
                <div className='vehicle_info'>
                    <h3>{row?.registration_number || '-'}</h3>
                    <p>{row?.brand ? `${row.brand} ${row.model}` : row?.model || '-'}</p>
                </div>
            </div>
            <div className='vehicle_details'>
                <div>
                    {meterIcon}
                    {row?.odm || row?.odo_meter || '-'} km
                </div>
                <div>
                    {locationIcon}
                    {row?.rto || '-'}
                </div>
            </div>
            <div className='vehicle_service_entries'>
                <div>
                    <h6>Service Entries</h6>
                    <button>View All</button>
                </div>
                {(row?.services || []).length === 0 && <p style={{ textAlign: 'center', color: "lightgray", fontStyle: "italic", marginTop: "4px", fontSize: "11px" }}>No Service Entry</p>}
                <div>
                    <ul>
                        {(row?.services || []).length > 0 ? (
                            row.services.map((service, idx) => (
                                <li key={idx}>{service?.service_id || '-'}</li>
                            ))
                        ) : null}
                    </ul>
                </div>
            </div>
            <div className='vehicle_issues'>
                <div>
                    <h6>Issues</h6>
                    <button>View All</button>
                </div>
                <div>
                    <ul>
                        {(row?.issues || []).length > 0 ? (
                            row.issues.map((issue, idx) => (
                                <li key={idx}>
                                    <span>{wrenchIcon} {issue.summery || '-'}</span>
                                </li>
                            ))
                        ) : <li>-</li>}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default VehicleCard